import { useEffect, useState } from "react";
import Web3 from "web3";
import contract from "../contracts/contract.json";
import Alt from "../assets/logo.png"
import ImageMinter from "../assets/frens-gif-new.gif"
import OpenSea from "../assets/open-sea-logo.png"
import Discord from "../assets/discord-logo.png"
import Twitter from "../assets/twitter-logo.png"
import YouTube from "../assets/youtube-logo.png"
import Reddit from "../assets/reddit-logo.png"

import GalaxiaStudios from "../assets/Galaxia-Studios.png"

import { alert } from 'react-custom-alert';
import Arena from "./Arena";

import useSound from 'use-sound';
import levelUpSound from '../sounds/level-up-3.mp3';
import mintSound from '../sounds/mint-2.mp3';


const initialInfoState = {
  connected: false,
  status: null,
  account: null,
  web3: null,
  contract: null,
  address: null,
  contractJSON: null,
};

const initialFrenState = {
  frenNumber: 1,
}

const initialStatusState = {
  loading: false,
  status: `Mint your ${contract.name} NFTs`,
}

const initialMintState = {
  // loading: false,
  // status: `Mint your ${contract.name} NFTs`,
  amount: 1,
  supply: "0",
  cost: "0",
  frens: [],
  playCost: "500000000000000",
  feedCost: "500000000000000",
  cleanCost: "500000000000000",
  reviveCost: "50000000000000000",
};

function Minter() {
  const [info, setInfo] = useState(initialInfoState);
  const [mintInfo, setMintInfo] = useState(initialMintState);
  const [frenInfo, setFrenInfo] = useState(initialFrenState);
  const [statusInfo, setStatusInfo] = useState(initialStatusState);

  const [name, setName] = useState('');

  const [playLevelUpSound] = useSound(levelUpSound, { volume: 0.5 });
  const [playMintSound] = useSound(mintSound, { volume: 0.5 });


  console.log(info);

  const init = async (_request, _contractJSON) => {
    try{
      var isMetaMaskInstalled = window.ethereum.isMetaMask;
    }
    catch{
      alert({ message: 'This is a Web3 Application! Please Install Metamask to use it! ', type: 'info'});
    }
    if (isMetaMaskInstalled) {
      try {
        const accounts = await window.ethereum.request({
          method: _request,
        });
        const networkId = await window.ethereum.request({
          method: "net_version",
        });
        if (networkId == _contractJSON.chain_id) {
          let web3 = new Web3(window.ethereum);
          setInfo((prevState) => ({
            ...prevState,
            connected: true,
            status: null,
            account: accounts[0],
            web3: web3,
            contract: new web3.eth.Contract(
              _contractJSON.abi,
              _contractJSON.address
            ),
            contractJSON: _contractJSON,
          }));
        } else {
          setInfo(() => ({
            ...initialInfoState,
            status: `Change network to ${_contractJSON.chain}.`,
          }));
          alert({ message:  `Please change network to ${_contractJSON.chain}.`, type: 'info' })
          await switchNetwork(_contractJSON.chain_id)
        }
      } catch (err) {
        console.log("error 1: ",err.message);
        // alert({ message: `Please try again in a few seconds..`, type: 'success' })
        setInfo(() => ({
          ...initialInfoState,
        }));
      }
    } else {
      console.log("error 10: ");
      setInfo(() => ({
        ...initialInfoState,
        status: "Please install metamask.",
      }));
    }
  };

  const initListeners = () => {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", () => {
        window.location.reload();
      });
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });
    }
  };

  const switchNetwork = async(chainId) => {
    let web3 = new Web3(window.ethereum);
      try {
        alert({ message:  `Changing network.. Confirm in wallet.`, type: 'info' })
        let chainId_hex = web3.utils.toHex(chainId)
        await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: chainId_hex}],
      });
      alert({ message: `You have succefully switched to ${info.contractJSON.chain_id} network`, type: 'success' })
      } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          console.log("This network is not available in your metamask, please add it")
        }
        console.log("Failed to switch to the network")
        console.log("Error: ",switchError)
      }
  }

  const getAllFrens = async () => {
    const params = {
      to: info.contractJSON.address,
      from: info.account,
      data: info.contract.methods.frens(1).encodeABI(),
    };
    try {
      const result = await window.ethereum.request({
        method: "eth_call",
        params: [params],
      });
      setMintInfo((prevState) => ({
        ...prevState,
        frens: info.web3.utils.hexToNumberString(result),
      }));
    } catch (err) {
      console.log("error 2: ",err.message);
      setMintInfo((prevState) => ({
        ...prevState,
        frens: [],
      }));
      getAllFrens();
    }
  };

  const getSupply = async () => {
    const params = {
      to: info.contractJSON.address,
      from: info.account,
      data: info.contract.methods.totalSupply().encodeABI(),
    };
    try {
      const result = await window.ethereum.request({
        method: "eth_call",
        params: [params],
      });
      // console.log(info.web3.utils.hexToNumberString(result));
      setMintInfo((prevState) => ({
        ...prevState,
        supply: info.web3.utils.hexToNumberString(result),
      }));
    } catch (err) {
      console.log("error 3: ",err.message);
      // setMintInfo((prevState) => ({
      //   ...prevState,
      //   supply: 0,
      // }));
      getSupply();
    }
  };

  const getCost = async () => {
    const params = {
      to: info.contractJSON.address,
      from: info.account,
      data: info.contract.methods.generationCost().encodeABI(),
    };
    try {
      const result = await window.ethereum.request({
        method: "eth_call",
        params: [params],
      });
      // console.log(info.web3.utils.hexToNumberString(result));
      setMintInfo((prevState) => ({
        ...prevState,
        cost: info.web3.utils.hexToNumberString(result),
      }));
    } catch (err) {
      console.log("error 4: ",err.message);
      // setMintInfo((prevState) => ({
      //   ...prevState,
      //   cost: "0",
      // }));
      getCost();
    }
  };

  const mint = async () => {
    alert({ message: "Minting a new Fren! Confirm transaction in wallet!", type: 'info' })
    const params = {
      to: info.contractJSON.address,
      from: info.account,
      value: String(
        info.web3.utils.toHex(Number(mintInfo.cost) * mintInfo.amount + 500000000000000) // The 100000000000000 is solving an issuse of overflow numbers when calculating the dynamic price.
      ),
      data: info.contract.methods
        .mint()
        .encodeABI(),
      gas: info.web3.utils.toHex(2000000),
    };
    try {
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: true,
        status: `Minting your Fren...`,
      }));
      const txHash = await window.ethereum.request({
        method: "eth_sendTransaction",
        params: [params],
      });
      await sendTransaction(txHash);   
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: false,
        status:
          "Nice! Your Fren is here!",
          // "Nice! Your Fren is here! 🐶 Time to take care of it.",
      }));
      playMintSound();
      await getSupply();
      await getCost();

    } catch (err) {
      console.log("error 5: ",err.message);
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: false,
        status: err.message,
      }));
      alert({ message: `${err.message}`, type: 'error' });
    }
  };

  const sendTransaction = async (txHash) => {
    alert({ message: `Transaction sent! `, type: 'info' });

    const receipt = await info.web3.eth.getTransactionReceipt(txHash);
    if (receipt && receipt.blockNumber) {
      // console.log("receipt: ",receipt)
      // console.log("Transaction has been confirmed in block number", receipt.blockNumber);
      // Transaction was successful and confirmed, you can proceed with the next step here
    } else {
      // console.log("receipt2: ",receipt)
      // console.log("Transaction is still pending.");
      alert({ message: `Transaction is pending confirmation...`, type: 'info' });
      // Transaction is still pending, wait for it to be confirmed
      const confirmedReceipt = await new Promise((resolve, reject) => {
        const checkConfirmation = async () => {
          const receipt = await info.web3.eth.getTransactionReceipt(txHash);
          if (receipt && receipt.blockNumber) {
            console.log("Transaction has been confirmed in block number", receipt.blockNumber);
            alert({ message: `Transaction was successful!`, type: 'success' });
            resolve(receipt);
            // console.log("receipt3: ",receipt)
          } else {
            setTimeout(checkConfirmation, 1500); // Check again in 1 second
          }
        };
        checkConfirmation();
      });
      // Transaction was confirmed, you can proceed with the next step here
      
    }
  };

  const play = async () => {
    alert({ message: 'Playing with Fren number '+frenInfo.frenNumber+"! Confirm transaction in wallet!", type: 'info' })
    const params = {
      to: info.contractJSON.address,
      from: info.account,
      value: String(
        info.web3.utils.toHex(Number(mintInfo.playCost)) 
      ),
      data: info.contract.methods
        .play(frenInfo.frenNumber)
        .encodeABI(),
    };
    try {
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: true,
        status: `Playing with Fren...`,
      }));
      const txHash = await window.ethereum.request({
        method: "eth_sendTransaction",
        params: [params],
      });
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: false,
        status:
          "Nice! Your fren's happiness increased.",
      }));
      // check if transaction is successful
      await sendTransaction(txHash);   
      playLevelUpSound();


      // getSupply();
    } catch (err) {
      console.log("error 6: ",err.message);
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: false,
        status: err.message,
      }));
      alert({ message: `${err.message}`, type: 'error' });
    }
  };

  const feed = async () => {
    alert({ message: 'Feeding Fren number '+frenInfo.frenNumber+"! Confirm transaction in wallet!", type: 'info' })
    const params = {
      to: info.contractJSON.address,
      from: info.account,
      value: String(
        info.web3.utils.toHex(Number(mintInfo.feedCost))
      ),
      data: info.contract.methods
        .feed(frenInfo.frenNumber)
        .encodeABI(),
    };
    try {
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: true,
        status: `Feeding Fren...`,
      }));
      const txHash = await window.ethereum.request({
        method: "eth_sendTransaction",
        params: [params],
      });
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: false,
        status:
          "Nice! Your fren's energy increased.",
      }));
      // check if transaction is successful
      await sendTransaction(txHash);      
      playLevelUpSound();


      // getSupply();
    } catch (err) {
      console.log("error 7: ",err.message);
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: false,
        status: err.message,
      }));
      alert({ message: `${err.message}`, type: 'error' });
    }
  };

  const clean = async () => {
    alert({ message: 'Cleaning Fren number '+frenInfo.frenNumber+"! Confirm transaction in wallet!", type: 'info' })
    const params = {
      to: info.contractJSON.address,
      from: info.account,
      value: String(
        info.web3.utils.toHex(Number(mintInfo.cleanCost))
      ),
      data: info.contract.methods
        .clean(frenInfo.frenNumber)
        .encodeABI(),
    };
    try {
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: true,
        status: `Cleaning Fren...`,
      }));
      const txHash = await window.ethereum.request({
        method: "eth_sendTransaction",
        params: [params],
      });
      // check if transaction is successful
      await sendTransaction(txHash);      
      playLevelUpSound();

      setStatusInfo((prevState) => ({
        ...prevState,
        loading: false,
        status:
          "Nice! Your fren's cleanliness increased.",
      }));
      // getSupply();
    } catch (err) {
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: false,
        status: err.message,
      }));
      alert({ message: `${err.message}`, type: 'error' });
    }
  };

  const revive = async () => {
    alert({ message: 'Reviving Fren number '+frenInfo.frenNumber+"! Confirm transaction in wallet!", type: 'info' })
    const params = {
      to: info.contractJSON.address,
      from: info.account,
      value: String(
        info.web3.utils.toHex(Number(mintInfo.reviveCost))
      ),
      data: info.contract.methods
        .revive(frenInfo.frenNumber)
        .encodeABI(),
    };
    try {
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: true,
        status: `Reviving Fren...`,
      }));
      const txHash = await window.ethereum.request({
        method: "eth_sendTransaction",
        params: [params],
      });
      // check if transaction is successful
      await sendTransaction(txHash);      
      playLevelUpSound();

      setStatusInfo((prevState) => ({
        ...prevState,
        loading: false,
        status:
          "Nice! Your fren is alive again.",
      }));
      // getSupply();
    } catch (err) {
      setStatusInfo((prevState) => ({
        ...prevState,
        loading: false,
        status: err.message,
      }));
      alert({ message: `${err.message}`, type: 'error' });
    }
  };

  const setNameToFren = async () => {
    alert({ message: 'Changing name of Fren number '+frenInfo.frenNumber+"! Confirm transaction in wallet!", type: 'info' })
    const params = {
      to: info.contractJSON.address,
      from: info.account,
      data: info.contract.methods
        .setFrenName(name, frenInfo.frenNumber)
        .encodeABI(),
    };
    try {
      setMintInfo((prevState) => ({
        ...prevState,
        loading: true,
        status: `Setting a name to Fren...`,
      }));
      const txHash = await window.ethereum.request({
        method: "eth_sendTransaction",
        params: [params],
      });
      // check if transaction is successful
      await sendTransaction(txHash);      
      playLevelUpSound();

      setMintInfo((prevState) => ({
        ...prevState,
        loading: false,
        status:
          "Nice! Your fren has a new name.",
      }));
      // getSupply();
    } catch (err) {
      setMintInfo((prevState) => ({
        ...prevState,
        loading: false,
        status: err.message,
      }));
      alert({ message: `${err.message}`, type: 'error' });
    }
  };
  
  const updateFrenNumber = (newNumber) => {
    if (newNumber >= 1) {
      setFrenInfo((prevState) => ({
        ...prevState,
        frenNumber: newNumber,
      }));
    }
  };

  // function should check if the string is not longer than 10 characters
  const handleNameChange = (event) => {
    if (event.target.value.length <= 10){
      setName(event.target.value);
    }else{
      alert({ message: `Name should be less than 10 characters!`, type: 'error' });
    }
  };


  const connectToContract = (_contractJSON) => {
    init("eth_requestAccounts", _contractJSON);
  };

  useEffect(() => {
    connectToContract(contract);
    initListeners();
  }, []);

  useEffect(() => {
    if (info.connected) {
      getSupply();
      getCost();
      // getAllFrens();
      // getFrensOfConnectedUser();

    }
  }, [info.connected]);

  return (
    <div className="page" >
      <div style={{ height: 32 }}></div>
      
      <div className="card">
        <div className="card_header">
          <img className="card_header_image ns" alt={Alt} src={ImageMinter} />
        </div>
        {mintInfo.supply < contract.total_supply ? (
          <div className="card_body">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* ************** Mint start here! ************** */}
              <div style={{ width: 10 }}></div>
              <button
                disabled={!info.connected || mintInfo.cost == "0"}
                className="button"
                onClick={() => mint()}
              >
                Mint A Fren!
              </button>
            </div>

            {/* ************** Mint ends here! ************** */}
            {/* ************** Flex List start here! ************** */}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >

              </div>
            {info.connected ? (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ color: "var(--statusText)", textAlign: "center" }}>
                  {info.web3?.utils.fromWei(mintInfo.cost, "ether") *
                    mintInfo.amount}{" "}
                  {contract.chain_symbol}
                </p>
                <div style={{ width: 20 }}></div>
                <p style={{ color: "var(--statusText)", textAlign: "center" }}>
                  |
                </p>
                <div style={{ width: 20 }}></div>
                <p style={{ color: "var(--statusText)", textAlign: "center" }}>
                  {mintInfo.supply}/{contract.total_supply}
                </p>
              </div>
            ) : null}
            {mintInfo.status ? (
              <p className="statusText">{mintInfo.status}</p>
            ) : null}
            {info.status ? (
              <p className="statusText" style={{ color: "var(--error)" }}>
                {info.status}
              </p>
            ) : null}
          </div>
        ) : (
          <div className="card_body">
            <p style={{ color: "var(--statusText)", textAlign: "center" }}>
              {mintInfo.supply}/{contract.total_supply}
            </p>
            <p className="statusText">
              We've sold out! .You can still buy and trade the {contract.name}{" "}
              on marketplaces such as Opensea.
            </p>
          </div>
        )}
        <div className="card_footer colorGradient">
          <button
            className="button"
            style={{
              backgroundColor: info.connected
                ? "var(--success)"
                : "var(--warning)",
            }}
            onClick={() => connectToContract(contract)}
          >
            {info.account ? "Connected" : "Connect Wallet"}
          </button>
          {info.connected ? (
            <span className="accountText">
              {String(info.account).substring(0, 8) +
                "..." +
                String(info.account).substring(34)}
            </span>
          ) : null}
        </div>
        <a
          style={{
            position: "absolute",
            bottom: -25,
            left: 82.5,
            color: "#ffffff",
          }}
          target="_blank"
          href="https://basescan.org/address/0x0299e017bb4f702136366cabffaecb516bd6c865"
        >
          View Smart Contract
        </a>
      </div>
      <div style={{ height: 25 }}></div>

  <div style={{color:"#c2feff", textAlign:"center" }}>
    
  <div style={{ height: 30 }}></div>


      <div>
      <div style={{backgroundColor: "#5112d9", padding: "20px"}}>
        <p style={{color: "#222", fontWeight: "bold" , color:"white", fontSize:"16px"}}>👋 Welcome to Frens On Chain!</p>
        <p style={{color: "#222", fontWeight: "bold" , color:"white"}}>🐶 Frens On Chain are 100% on-chain generated, dynamic NFTs and your new on-chain frens!</p>
        <p style={{color: "#222", fontWeight: "bold" , color:"white"}}>🍽️ Take care of your fren by feeding it, playing with it and cleaning it!</p>
        <p style={{color: "#222", fontWeight: "bold" , color:"white"}}>👀 Your fren will appreciate that and its appearance will change accordingly!</p>
        <p style={{color: "#222", fontWeight: "bold" , color:"white"}}>🌟 Frens On Chain last forever!</p>
      </div>
    </div>

    <div style={{paddingTop:75, paddingBottom:30 , display: !info.connected ? "none": ""}}>
            <Arena info={info} mintInfo={mintInfo} play={play} feed={feed} clean={clean} revive={revive} mint={mint} updateFrenNumber={updateFrenNumber} getAllFrens={getAllFrens} getSupply={getSupply} getCost={getCost} />
    </div>


    <div style={{ height: 30 }}></div>

      <div style={{fontSize:16}}>
        How to play Frens On Chain:
      </div>
      <div style={{ height: 20 }}></div>

      </div>
      <ul class="a" >
      {/* <li >Frens On Chain : <div style={{color:"#c2feff"}}><i>on chain frens last forever. </i></div></li> */}
      <li>Step 1: Meet Your Fren!</li>
      <div style={{ height: 10 }}></div>
      <ul>Mint your Fren through the dynamic NFT process and witness the magic of on-chain generation.<br/> Each Fren is a one-of-a-kind companion that you can name, love, and care for!</ul>
      <div style={{ height: 10 }}></div>
      <li>Step 2: Nurture and Care!</li>
      <div style={{ height: 10 }}></div>
      <ul>Your Fren comes with three essential attributes: Happiness, energy, and cleanliness.<br/> Just like real pets, these attributes need your attention to thrive. Each day, they decrease by one. Keep a close eye on them!</ul>
      <div style={{ height: 10 }}></div>
      <li>Step 3: Be the Ultimate Caretaker!</li>
      <div style={{ height: 10 }}></div>
      <ul>Interact with your Fren using fun functions:</ul>
      <ul>🍔 Feed: Boost your Fren's energy by 3 points with a scrumptious meal! Keep them energized and ready for exciting adventures.</ul>
      <ul>🎮 Play: Make your Fren's day with some playtime fun! Increase their happiness by 3 points and watch their joyous expressions light up your screen.</ul>
      <ul>🚿 Clean: Keep your Fren sparkling clean and happy by raising their cleanliness by 3 points. A clean Fren is a happy Fren!</ul>
      <div style={{ height: 10 }}></div>
      <li>Step 4: Mood Magic!</li>
      <div style={{ height: 10 }}></div>
      <ul>Watch your Fren's mood transform based on their attributes:</ul>
      <ul>😄 Happy Fren: All attributes above 70! Your Fren will wear a big, bright smile, radiating pure happiness.</ul>
      <ul>😊 Natural Fren: All attributes above 40. The smile takes a break, showcasing a calm and content demeanor.</ul>
      <ul>😢 Sad Fren: If any attribute dips below 40, your Fren will visibly express their sadness, signaling that they need your attention and care.</ul>
      <div style={{ height: 10 }}></div>
      <li>Step 5: Dynamic Evolution!</li>
      <div style={{ height: 10 }}></div>
      <ul>Your Fren's appearance changes as their attributes change. Witness your Fren's image dynamically adapt to their mood and attributes, making every interaction a delightful surprise!</ul>
      <div style={{ height: 10 }}></div>
      <li>Step 6: Cherish and Revive!</li>
      <div style={{ height: 10 }}></div>
      <ul>Remember, your Fren depends on you for their well-being. If any attribute drops below 0, your Fren will need your help to revive. <br/>Use the revive function, but keep in mind, there's a small fee. <br/>Take care of your Fren to avoid this sad situation!</ul>
      <div style={{ height: 10 }}></div>
      <li>Step 7: Get Ready to Fren-gage!</li>
      <div style={{ height: 10 }}></div>

      <ul>Frens On Chain is all about fostering a meaningful bond with your digital pet. Experience the joy of nurturing, playing, and connecting with your Fren in the on-chain universe.<br/> Let's create memories and embark on this heartwarming adventure together! So, what are you waiting for? Start your Fren journey now and let the Fren-tastic times roll!</ul>
      </ul  >
      <div style={{color:"#c2feff"}}>
      <div style={{ height: 20 }}></div>

       On chain frens last forever! ❤️
      </div>
      <div style={{ height: 42 }}></div>

      {/* <div style={{color:"#c2feff", textAlign:"center", marginTop: "10px", padding: "20px", backgroundColor: "#222"}}>
    <p>Welcome to Frens On Chain: Your Digital Pet Adventure!</p>
    <p>🌟 Get Ready to Embark on a Fren-tastic Journey! 🌟</p>
    <p>Take care of your fren by feeding it, playing with it and cleaning it.</p>
    <p>Are you ready to dive into the world of adorable, on-chain companions? <br/> Say hello to your new digital friend, your Fren! Get ready to nurture, play, and build a lifelong bond with your unique on-chain buddy.</p>
    <p>Remember, Frens On Chain last forever!</p>
  </div>
  <div style={{ height: 20 }}></div> */}

            {/* ************** text area ends here! ************** */}
    <div style={{ display: "grid",  gridTemplateColumns: "repeat(5, 10fr)", gridGap: 15 }}>
      <div className="img-hover"> 
        <a href="https://discord.gg/SkEfBbX75E" target="_blank" rel="noopener noreferrer" >
        <img src={Discord} height={50} width={50} style={{borderRadius:50, border:"2px solid white"}} />
        </a>
      </div>
      <div className="img-hover"> 
        <a href="https://opensea.io/collection/frens-on-chain-base" target="_blank" rel="noopener noreferrer">
        <img src={OpenSea} height={50} width={50} style={{borderRadius:50, border: 10, border:"2px solid white"}}/>
        </a>
      </div>
      <div className="img-hover"> 
        <a href="https://twitter.com/Galaxia3Studios" target="_blank" rel="noopener noreferrer">
        <img src={Twitter} height={50} width={50} style={{borderRadius:50, border: 10, border:"2px solid white"}}  />
        </a>
      </div>
      <div className="img-hover"> 
        <a href="https://www.reddit.com/r/GalaxiaStudios/" target="_blank" rel="noopener noreferrer">
        <img src={Reddit} height={50} width={50} style={{borderRadius:50, border:"2px solid white"}}/>
        </a>
      </div>
      <div className="img-hover"> 
        <a href="https://www.youtube.com/@GalaxiaStudios" target="_blank" rel="noopener noreferrer">
        <img src={YouTube} height={50} width={50} style={{borderRadius:50, border:"2px solid white"}}/>
        </a>
      </div>      
    </div>
    <div style={{ height: 32 }}></div>
      <div className="img-hover"> 
        <a href="https://www.galaxiastudios.com/" target="_blank" rel="noopener noreferrer">
        <img src={GalaxiaStudios} height={70} width={70} style={{borderRadius:50, border:"2px solid white"}}/>
        </a>
      </div>
      <div style={{ height: 32 }}></div>
    </div>
    
    
  );
}

export default Minter;
